
URL = globalThis.URL
import __vite__wasmUrl from "/vercel/path0/packages/ttml-processor/pkg/ttml_processor_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./ttml_processor_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./ttml_processor_bg.js": { "__wbg_set_3f1d0b984ed272ed": __vite__wasmImport_0["__wbg_set_3f1d0b984ed272ed"],
"__wbg_new_25f239778d6112b9": __vite__wasmImport_0["__wbg_new_25f239778d6112b9"],
"__wbg_new_1ba21ce319a06297": __vite__wasmImport_0["__wbg_new_1ba21ce319a06297"],
"__wbg_set_7df433eea03a5c14": __vite__wasmImport_0["__wbg_set_7df433eea03a5c14"],
"__wbg___wbindgen_throw_dd24417ed36fc46e": __vite__wasmImport_0["__wbg___wbindgen_throw_dd24417ed36fc46e"],
"__wbg___wbindgen_debug_string_adfb662ae34724b6": __vite__wasmImport_0["__wbg___wbindgen_debug_string_adfb662ae34724b6"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"],
"__wbindgen_cast_d6cd19b81560fd6e": __vite__wasmImport_0["__wbindgen_cast_d6cd19b81560fd6e"],
"__wbindgen_cast_2241b6af4c4b2941": __vite__wasmImport_0["__wbindgen_cast_2241b6af4c4b2941"] } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const init = __vite__wasmModule.init;
export const parse_ttml = __vite__wasmModule.parse_ttml;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_realloc = __vite__wasmModule.__wbindgen_realloc;
export const __wbindgen_externrefs = __vite__wasmModule.__wbindgen_externrefs;
export const __externref_table_dealloc = __vite__wasmModule.__externref_table_dealloc;
export const __wbindgen_start = __vite__wasmModule.__wbindgen_start;
